const installationInstructions = {
  powerDevice: {
    currentStep: 'powerDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    prevStepName: 'https://return-to-app',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/switch/switch_power.png'),
    resourceType: 'image',
    primaryTx: 'categories.switch.powerDevice.title',
    secondaryTx: 'categories.switch.powerDevice.subtitle',
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'powerDevice',
      titleTx: 'categories.switch.stepsToReset',
    },
  },
  confirmPairingMode: {
    currentStep: 'confirmPairingMode',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/switch/switch_pairing_mode.png'),
    resourceType: 'image',
    primaryTx: 'categories.switch.confirmPairingMode.title',
    secondaryTx: 'categories.switch.confirmPairingMode.subtitle',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    primaryActionKey: 'chooseProvider', // Choose Pepper or Tuya FW
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'confirmPairingMode',
      titleTx: 'categories.switch.stepsToReset',
    },
  },
  resetDevice: {
    headerIcon: 'closeBlack',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    currentStep: 'resetDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    headerTitleTx: 'categories.switch.stepsToReset',
    carousel: {
      showPageIndicator: true,
      slides: [
        {
          resourceType: 'image',
          resource: require('@/assets/categories/switch/reset_switch_step_1.png'),
          primaryTx: 'categories.switch.resetDevice.step1.title',
          secondaryTx: 'categories.switch.resetDevice.step1.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/switch/reset_switch_step_2.png'),
          primaryTx: 'categories.switch.resetDevice.step2.title',
          secondaryTx: 'categories.switch.resetDevice.step2.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/switch/reset_switch_step_3.gif'),
          primaryTx: 'categories.switch.resetDevice.step3.title',
          secondaryTx: 'categories.switch.resetDevice.step3.subtitle',
        }
      ]
    }
  },
};

export default installationInstructions;
